import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import request from "@/utils/request";
// 根据角色获取绑定的用户
export function getUserByRole(data) {
  return request({
    url: "/Accounts/User/GetUserByRole",
    method: "post",
    params: data
  });
}
// 用户列表
export function getUserList(data) {
  return request({
    url: "/Accounts/User/GetByPageList",
    method: "post",
    data: data
  });
}
// 用户详情
export function getModel(data) {
  return request({
    url: "/Accounts/User/GetUser",
    method: "post",
    params: data
  });
}
// 禁用、启用
export function enableUser(data) {
  return request({
    url: "/Accounts/User/EnableUser",
    method: "post",
    data: data
  });
}
// 新增、编辑
export function addOrEdit(data) {
  return request({
    url: "/Accounts/User/AddOrEdit",
    method: "post",
    data: data,
    timeout: 60000
  });
}
// 所有用户列表
export function getAllUser(data) {
  return request({
    url: "/Accounts/User/GetAllUser",
    method: "post",
    data: data
  });
}
// 导入用户
export function importUser(data) {
  return request({
    url: "/Accounts/User/UploadUserList",
    method: "post",
    data: data
  });
}
// 下载模板
export var downloadTemplateFile = function downloadTemplateFile() {
  return request({
    url: "/Accounts/User/DownLoadTemplate",
    method: "get",
    responseType: "arraybuffer"
  });
};
// 用户绑定权限
export var getUserBinding = function getUserBinding(data) {
  return request({
    url: "/Accounts/User/GetUserBinding",
    method: "post",
    params: data
  });
};
// 设置用户绑定权限
export var setUserBinding = function setUserBinding(data) {
  return request({
    url: "/Accounts/User/SetUserBinding",
    method: "post",
    data: data
  });
};

// 注册用户
export function registerUser(data) {
  return request({
    url: "/Accounts/User/RegisterUser",
    method: "post",
    data: data
  });
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: "/Accounts/User/ResetPassword",
    method: "post",
    data: data
  });
}
// 修改密码
export function changePassword(data) {
  return request({
    url: "/Accounts/User/RevisePassword",
    method: "post",
    data: data
  });
}

// 获取手机验证码
export function getPhoneVerifyCode(data) {
  return request({
    url: "/Accounts/User/GetPhoneVerifyCode",
    method: "post",
    params: data
  });
}

// 获取邮箱验证码
export function getEmailVerifyCode(data) {
  return request({
    url: "/Accounts/User/GetEmailVerifyCode",
    method: "post",
    params: data
  });
}
// 验证用户账号是否存在
export function verifyUserAccount(data) {
  return request({
    url: "/Accounts/User/VerifyUserAccount",
    method: "post",
    params: data
  });
}

// cas权限用户登出
export function logout() {
  return request({
    url: "/auth/Logout",
    method: "post"
  });
}
export function login(data) {
  return request({
    url: "/user/login",
    method: "post",
    data: data
  });
}
export function getInfo(token) {
  return request({
    url: "/user/info",
    method: "get",
    params: {
      token: token
    }
  });
}

/**
 * 获取用户权限菜单
 * @param  {Object} data
 */
export function getMenus(data) {
  return request({
    url: "/User/GetMenuAuthor",
    method: "post",
    params: _objectSpread({}, data)
  });
}
// 获取用户类型下拉框
export function getUserType(data) {
  return request({
    url: "/Accounts/User/GetUserType",
    method: "post",
    data: data
  });
}
// 获取所有系统列表
export function getAllSystem(data) {
  return request({
    url: "/System/BusinessSystem/GetAllSystem",
    method: "post",
    data: data
  });
}
// 分页获取用户日志列表
export function getLogByPageList(data) {
  return request({
    url: "/Accounts/User/GetLogByPageList",
    method: "post",
    data: data
  });
}

// 获取用户应用权限(获取所有系统列表)
export function getAllApp(data) {
  return request({
    url: "/ums/user/authority/app/list",
    method: "get",
    data: data
  });
}

// 获取当前登录人用户信息
export function getUserInfov2() {
  return request({
    url: '/ums/user/user/info/v2',
    method: "GET"
  });
}